<style scoped>
    .menu-c {
        display: flex;
        flex-direction: column;
        z-index: 20;
        background: white;
    }
    .search-c {
        padding: 10px;
    }
    .content-c {
        flex: 1;
        overflow: auto;
        padding: 10px;
    }
    .content-item {
        padding: 10px 10px 0;
         cursor: pointer;
    }
        .content-item:hover {
        background: #eeeeee;
    }
    .i-con {
        cursor: pointer;
        margin: 0px 5px;
    }
</style>
<template>
  <v-menu
    ref="menu"
    v-model="menu"
    content-class="menu-c"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    top
    :max-height="contentHeigh"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        履约中台分配仓库
      </v-btn>
    </template>
    <div
      class="content-c"
    >
      <table class="mis-table">
        <tr>
          <th>
            仓库
          </th>
          <th>数量</th>
          <th>操作</th>
        </tr>
        <tr
          v-for="(csw, index) in my_value"
          :key="index"
        >
          <td>
            <v-select
              v-model="csw.warehouse_id"
              style="max-width:260px"
              :items="warehouses"
              size="small"
              placeholder="选择仓库"
              item-text="name"
              item-value="id"
              @change="(val)=>change(index,val)"
            />
          </td>
          <td>
            <NumberField
              v-model="my_value[index]"
              :field="{
                key: 'qty',
              }"
              style="width:100px"
            />
          </td>
          <td>
            <div style="width:70px">
              <span
                v-if="index===my_value.length-1"
                class="i-con"
                @click="add"
              >
                <v-icon color="primary">
                  mdi-plus-circle-outline
                </v-icon>
              </span>
              <span
                v-if="1!==my_value.length"
                class="i-con"
                @click="()=>del(index)"
              >
                <v-icon color="error">
                  mdi-minus-circle-outline
                </v-icon>
              </span>
              <span
                v-if="my_value.length===1"
                class="i-con"
                @click="clear"
              >
                <v-icon color="error">
                  mdi-delete
                </v-icon>
              </span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </v-menu>
</template>
<script>
  import {mapGetters} from 'vuex'
  // import IntegerField from '@/vuetify_custom/v-form/components/Integer_Field.js'
  import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
  import {createContractStockWarehouses} from '../utils'
  export default {
    components: {
      // IntegerField,
      NumberField
    },
    props: {
      outList: {
        type: Array,
        default: () => []
      },
      value: {
        type: Array
      },
      text: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      prependIcon: {
        type: String,
      },
      url: {
        type: String,
      },
      search_key: {
        type: String,
        default: () => 'search'
      },
      outParams: {
        type: Object,
        default: () => ({})
      },
      handleSearch: {
        type: Function
      },
      render: {
        type: Function,
      },
      contentHeigh: {
        type: Number,
        default:() => 250
      },
      valueRender: {
        type: Function,
      }
    },
    data() {
      return {
        menu: false,
        date: '',
        in_params: {
          [this.search_key]: '',
        },
        list: [],
        history_item_hash: {},
        getListLoading: false,
        my_value: this.value
      }
    },
    computed: {
      ...mapGetters({
        warehouses: 'async/warehouses',
        warehouses_hash: 'async/warehouses_hash',
      }),
      item_hash() {
        const hash = {}
        const outList = this.outList || []
        outList.forEach(item => {
          const key = item[this.valueKey]
          hash[key] = item
        })
      
        return Object.assign(this.history_item_hash, hash)
      }
    },
    watch: {
      my_value(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.my_value = val
      },
      menu(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    methods: {
      clear() {
        this.my_value = [createContractStockWarehouses()]
      },
      change(index, val) {
        this.my_value[index].name = this.warehouses_hash[val].name
      },
      del(index) {
        this.my_value.splice(index, 1)
      },
      add() {
        this.my_value.push(createContractStockWarehouses())
      },
    }
  }
</script>
